export default __webpack_public_path__ + "static/media/galleryimg3.f15b8c9f.jpg";